export default function parseErrorMessage(errorType: Error) {
    if (errorType instanceof TypeError)
        return 'Vegkart finner ikke vegobjektene. Vennligst kontakt support om du mener de skal eksistere.';
    else
        return 'Ukjent feil! Vennligst kontakt support om problemet ikke løser seg med valgene over.';
}
